'use client';

import { Label as RadixLabel, type LabelProps as RadixLabelProps } from '@radix-ui/react-label';
import clsx from 'clsx';

import Text, { type TextProps } from '@commons/components/Text';

import styles from './index.module.scss';

/**
 * Label component props.
 *
 * Based on the Radix label primitive props.
 */

export type LabelProps = RadixLabelProps & {
  required?: boolean;
  className?: string;
  active?: boolean;
  error?: boolean;
  textProps?: Partial<TextProps>;
};

/**
 * Label component based on Radix label primitive.
 */

export const Label = ({
  children,
  required,
  className,
  textProps,
  active,
  error = false,
  ...props
}: LabelProps) => {
  const classes = clsx(styles.wrapper, className);

  const requiredAsterisk = required && (
    <Text as="span" weight="bold" className={clsx(styles.label, error && styles.error)}>
      &nbsp;*
    </Text>
  );

  return (
    <RadixLabel className={classes} {...props}>
      <Text
        as="span"
        weight="normal"
        className={clsx(styles.label, error && styles.error, active && styles.active)}
        {...textProps}
      >
        {children}
      </Text>
      {requiredAsterisk}
    </RadixLabel>
  );
};

export default Label;
